export const UPDATE_PHONE_STAGE_ONE = 'UPDATE_PHONE_STAGE_ONE';
export const UPDATE_PHONE_STAGE_TWO = 'UPDATE_PHONE_STAGE_TWO';



// WEBPACK FOOTER //
// ./app/constants/updatePhoneStages.js